import {
    getMinLeftAndTop,
    getMaxLeftAndTop
} from './utils.js';

const BETWEEN_SIZE = 50;

/**
 * placeElement: ensures that a new window (i.e. the argument element) being placed
 * at the coordinates x,y does not overlap any other windows.
 * it moves these other windows to ensure this.
 *
 * x : x coordinate of element being placed
 * y : y coordinate of element being placed
 * id : id of element being placed
 * element: element (the DOM object) being placed
 * idToElement: mapping from id to DOM element for every window in this canvas
 */

export const placeElement = (x, y, id, element, idToElement, coords={}, visited={}) => {
    if (!visited[id]) {
        visited[id] = 0;
    }
    visited[id]++;

    for (let _id in idToElement) {
        if (_id === id || visited[_id] > 6) {
            continue;
        }
        let _element = idToElement[_id].current;
        if (!_element) {
            continue;
        }


        let _coords = {...coords};
        _coords[id] = {x, y};
        let isOverlapping = overlaps(element, _element, id, _id, _coords);
        if (isOverlapping) {
            // then we need to shift to the right
            let coord = {x: _element.offsetLeft, y: _element.offsetTop};
            if (coords[_id]) {
                coord = coords[_id];
            }
            let newCoord = {
                x: coord.x + element.offsetWidth + BETWEEN_SIZE,
                y: coord.y
            };

            coords[_id] = newCoord;

            coords = {
                ... coords,
                ... placeElement(newCoord.x, newCoord.y, _id, _element, idToElement, coords, visited)
            };
        }
    }
    return coords;
};

/*
export const placeElement = (x, y, id, element, idToElement) => {
    let newCoords = {};
    let {offsetWidth, offsetHeight} = element;
    let elements = Object.values(idToElement);
    let {maxLeft, maxTop} = getMaxLeftAndTop(elements);
    let {minLeft, minTop} = getMinLeftAndTop(elements);
    let _idToElement = {};

    for (let _id in idToElement) {
        let _element = idToElement[_id].current;
        if (!_element || _id === id) { continue; }
        if (_element.offsetLeft + _element.offsetWidth > x &&
            _element.offsetHeight + _element.offsetTop > y) {
            _idToElement[_id] = _element;
        }
    }

    if (!Object.values(_idToElement).some(
        _element => overlaps(element, _element))) {
        // none of the elements overlap so just place as normal
        return {};
    }

    for (let _id in _idToElement) {
        let _element = _idToElement[_id];
        // then we shift
        newCoords[_id] = {
            x: _element.offsetLeft + offsetWidth + BETWEEN_SIZE,
            y: _element.offsetTop// + offsetHeight
        };
    }
    return newCoords;
};
*/

export const overlaps = (elementA, elementB, idA, idB, coords) => {
    let x1 = elementB.offsetLeft;
    let y1 = elementB.offsetTop;
    let x2 = elementB.offsetWidth + x1;
    let y2 = elementB.offsetHeight + y1;
    if (coords && coords[idB] !== undefined) {
        x1 = coords[idB].x;
        y1 = coords[idB].y;
        x2 = elementB.offsetWidth + coords[idB].x;
        y2 = elementB.offsetHeight + coords[idB].y;
    }
    return inSelection(
        elementA, x1, y1, x2, y2, idA, coords);
};

export const inSelection = (element, x1, y1, x2, y2, id, coords) => {
    if (!element) {
        return false;
    }
    let R1 = {
        x1,
        y1,
        x2,
        y2,
    };
    let R2 = {
        x1: element.offsetLeft,
        y1: element.offsetTop,
        x2: element.offsetLeft + element.offsetWidth,
        y2: element.offsetTop + element.offsetHeight,
    };

    if (coords && coords[id] !== undefined) {
        R2.x1 = coords[id].x;
        R2.y1 = coords[id].y;
        R2.x2 = coords[id].x + element.offsetWidth;
        R2.y2 = coords[id].y + element.offsetHeight;
    }

    return (R1.x1 <= R2.x2 && R1.x2 >= R2.x1 &&
            R1.y1 <= R2.y2 && R1.y2 >= R2.y1) ;
};


